import React from "react";
import "./spinner.component.scss";

const Spinner = () => {
  return (
    <div className="spinner_layout">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
